module.exports = __webpack_public_path__ + "static/img/steps.b50dcf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/steps.png
// module id = FSsi
// module chunks = 0